import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EntityConfig } from '../_appCommon/base/EntityConfig';
import { EntityDataServiceBase } from '../_appCommon/base/EntityDataServiceBase';

@Injectable()
export class CaseHistoryDataService extends EntityDataServiceBase
{
  constructor(protected http: HttpClient)
  {
    super(http, 'caseHistory');
  }

  protected loadEntityConfig(): void
  {
    this.entityConfig = new EntityConfig();

    this.entityConfig.entityDisplayName = 'caseHistory';
    this.entityConfig.apiUrl = 'api/CaseHistory';
  }
}

